import { IComponentOptions } from "angular";
import { ContractGridComponentController } from "./controller";

export const vsComponentName = "contractGridComponent";

export const contractGridComponentOptions: IComponentOptions = {
  controller: ContractGridComponentController,
  controllerAs: "processGridController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    gridConfiguration: "<",
    contractType: "<",
  },
};
